import { render, staticRenderFns } from "./ClinicPrescriptions.vue?vue&type=template&id=236ee10f"
import script from "./ClinicPrescriptions.vue?vue&type=script&lang=js"
export * from "./ClinicPrescriptions.vue?vue&type=script&lang=js"
import style0 from "./ClinicPrescriptions.vue?vue&type=style&index=0&id=236ee10f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports